import React from 'react'
import moment from 'moment'

const ProcedimentosSolicitados = ({ dadosRelatorio, filters, utilizaValorCusto }) => {
  const { dataInicial, procedimento, profissional, dataFinal } = filters

  const columnColor = (index) => {
    if (index % 2 !== 0) {
      return { backgroundColor: "#F2F2F2" }

    }
    return ''
  }
  return (
    <>
      <div style={styles.titulo}>Relatório de Procedimentos solicitados</div>
      <div style={styles.subTitulo}>
        {dataInicial && (
          <div style={styles.dataInicio}>
            Data Inicio:
            <span style={styles.subTituloSpan}>{moment(dataInicial).format('DD/MM/YYYY')}</span>
          </div>
        )}
        {dataFinal && (
          <div style={styles.dataInicio}>
            Data Fim:
            <span style={styles.subTituloSpan}>{moment(dataFinal).format('DD/MM/YYYY')}</span>
          </div>
        )}
        {profissional && (
          <div>
            Profissional:
            <span style={styles.subTituloSpan}>{profissional?.nome}</span>
          </div>
        )}
        {procedimento && (
          <div>
            Procedimento:
            <span style={styles.subTituloSpan}>{procedimento?.nome}</span>
          </div>
        )}
      </div>
      <div style={styles.headerColumn}>
        <div style={styles.column}>Profissionais</div>
        <div style={styles.column}>Data</div>
        <div style={styles.column}>Procedimento</div>
       {utilizaValorCusto && <div style={styles.column}>Valor custo</div>}
        <div style={styles.column}>Agendado</div>
      </div>
      <div>
        {dadosRelatorio.map((item, index) => {
          return (
            <div key={item.id} style={{ ...styles.containerColuna, ...columnColor(index) }}>
              <div style={styles.column}>{item.profissionalSaude?.nome}</div>
              <div style={styles.column}>
                {item?.dataHoraLancamento
                  ? moment(item.dataHoraLancamento).format('DD/MM/YYYY')
                  : ''}
              </div>
              <div style={styles.column}>{item.procedimento?.nome}</div>
             {utilizaValorCusto && <div style={styles.column}>{item?.valorCusto}</div>}
              <div style={styles.column}>{item.agendado ? 'Sim' : 'Não'}</div>
            </div>
          )
        })}
      </div>
    </>
  )
}

const styles = {
  titulo: {
    marginLeft: '0px',
    marginBottom: '10px',
    marginTop: '5px',
    paddingBottom: '5px',
    textAlign: 'center',
    fontWeight: 700,
  },
  subTitulo: {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: '1px solid #505050',
    marginBottom: '15px',
    paddingBottom: '5px',
    fontWeight: 700,
    justifyContent: 'center',
  },
  subTituloSpan: {
    marginLeft: '8px',
  },
  dataInicio: {
    marginRight: '16px',
  },
  headerColumn: {
    display: 'flex',
    flexDirection: 'row',
    fontWeight: 700,
    width: '100%',
  },
  containerColuna: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  column: {
    width: '100%',
  },
}

export default ProcedimentosSolicitados
